// printerService.js

export const connectToPrinter = (ipAddress) => {
  return new Promise((resolve, reject) => {
    const ePosDevice = new window.epson.ePOSDevice();

    ePosDevice.connect(
      ipAddress,
      8043,
      (result) => {
        if (result === "OK") {
          resolve(ePosDevice);
        } else {
          resolve(null);
          reject(`Failed to connect to the printer: ${result}`);
        }
      },
      { eposprint: true }
    );
  });
};

export const printText = (ePosDevice, text) => {
  return new Promise((resolve, reject) => {
    try {
      ePosDevice.createDevice(
        "local_printer",
        ePosDevice.DEVICE_TYPE_PRINTER,
        {},
        (printer, code) => {
          console.log(printer, "here");
          printer.onreceive = (response) => {
            console.log(response);
            if (response.success) {
              resolve("Print success!");
            } else {
              reject("Print failed");
            }
          };

          printer.addText(text);
          printer.print();
        }
      );
    } catch (err) {
      console.log(err);
    }
  });
};

export const printImage = (ePosDevice, base64Image) => {
  return new Promise((resolve, reject) => {
    ePosDevice.createDevice(
      "local_printer",
      ePosDevice.DEVICE_TYPE_PRINTER,
      { crypto: false, buffer: false },
      async (printer, code) => {
        printer.onreceive = (response) => {
          console.log(response);
          if (response.success) {
            resolve("Print success!");
          } else {
            reject("Print failed");
          }
        };

        const canvas = window.document.createElement("canvas");
        const context = canvas.getContext("2d");
        const img = new Image();
        img.crossOrigin = "Anonymous"; // Handle CORS if the image is from another
        img.src = base64Image;

        img.onload = () => {
          console.log("iam not loading");
          const printableWidth = 384; // Example width in dots (adjust based on your printer)
          const printableHeight = 900; // Example height in dots (adjust based on your printer)
          // Create a canvas element
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Set canvas size to image dimensions
          canvas.width = img.width;
          canvas.height = img.height;

          const scaleWidth = canvas.width / img.width;
          const scaleHeight = canvas.height / img.height;
          const scale = Math.min(scaleWidth, scaleHeight);

          // Calculate new image dimensions
          const newWidth = img.width * scale;
          const newHeight = img.height * scale;
          // Draw the image onto the canvas
          ctx.drawImage(img, 0, 0);

          // Append the canvas to the document body (or any other DOM element)
          // document.body.appendChild(canvas);

          // Optionally, you can log or use the canvas data
          // console.log(canvas.toDataURL()); // Logs the canvas content as a base64 string

          printer.addImage(ctx, 0, 0, 576, canvas.height);
          printer.addFeedLine(2); // Add line feeds (spacing)
          printer.addCut(printer.CUT_FEED); // Add a cut command to finish the print job
          printer.addPulse();
          // Send the print data to the printer
          printer.send();
        };
      }
    );

    // Create a temporary canvas to print the image
  });
};
